import { RichText } from '@/components/shared/rich-text'
import { FeatureMatrixStoryblok } from '@/lib/types/component-types-sb'
import { cn } from '@/lib/utils'
import { storyblokEditable } from '@storyblok/react/rsc'
import { DynamicIcon } from 'lucide-react/dynamic'

type FeatureMatrixProps = {
  blok: FeatureMatrixStoryblok
}

export function FeatureMatrix({ blok }: FeatureMatrixProps) {
  const layout = blok.layout ?? 'stacked'

  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border has-y-borders border-y py-10"
    >
      <div
        className={cn(
          'page-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
          layout === 'stacked' && 'gap-6',
        )}
      >
        {blok.items?.map((item, i) => (
          <div
            {...storyblokEditable(item)}
            key={item._uid}
            className={cn({
              'flex p-6 lg:p-3': true,
              'flex-col gap-3 p-2 lg:gap-6': layout === 'stacked',
              'flex-row items-center gap-3': layout === 'horizontal',
            })}
          >
            {item.icon && (
              <DynamicIcon
                key={item._uid + item.icon}
                size={40}
                className="text-brand"
                strokeWidth={1.5}
                name={item.icon as any}
              ></DynamicIcon>
            )}
            <div key={item._uid + 'content'}>
              <h3 className="text-accent-foreground font-semibold">{item.title}</h3>
              <RichText
                className="text-muted-foreground"
                content={item.content}
              ></RichText>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
